type ClassValues = string | boolean | null | undefined;

export const getClassName = (
  names: Array<ClassValues> | Record<string, ClassValues>
) => {
  if (Array.isArray(names)) {
    return names.filter(Boolean).join(' ');
  }

  return Object.entries(names)
    .map(([key, value]) => value && key)
    .filter(Boolean)
    .join(' ');
};
